// Replaces @mantine/hooks' useDebouncedValue at the ported call sites
// (ADR-0010 keeps Mantine out). One home — RawDataPage, the workbench and the
// sheet must not each grow a private copy with a different delay.
import { useEffect, useState } from 'react'

export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms)
    return () => clearTimeout(t)
  }, [value, ms])
  return v
}
